import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	password: string
}

interface ResponseDataShape {
	success: boolean
}

export async function companySelfDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/company/self/delete/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	await requester.sendRequest(payload, token)
}
